const state = {
  reportTypes: null
}

const getters = {
  reportTypes: state => state.reportTypes
}

const mutations = {
  SET_REPORT_TYPES (state, reportTypes) {
    state.reportTypes = reportTypes
  }
}

export default {
  state,
  getters,
  mutations
}
